import React, { memo } from "react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import { getFormatDate } from "@/helpers/utils";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import ImageRP from "@/components/ImageRP";
import TablePagination from "@/components/tables/TablePagination";
import { getImage } from "@/helpers/utils";
import type { ResourceArticle, ResourcePaginationHandler } from "../types";

const StyledCard = styled(Card)(() => ({
  borderRadius: "var(--radius-container)",
  height: "100%",
}));

const StyledCardActionArea = styled(CardActionArea)(() => ({
  minHeight: "200px",
}));

const DateLine = styled("div")(({ theme }) => ({
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    left: "0",
    bottom: "-2px",
    width: "32%",
    height: "2px",
    backgroundColor: theme?.palette?.primary?.main,
  },
}));

const Title = styled("div")(() => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitLineClamp: 3,
}));

interface ArticleSectionProps {
  articles?: ResourceArticle[];
  totalArticles: number;
  articlesPageIndex: number;
  articlesPageSize: number;
  handleArticlePageChange: ResourcePaginationHandler;
}

export default memo(function ArticleSection({
  articles,
  totalArticles,
  articlesPageIndex,
  articlesPageSize,
  handleArticlePageChange,
}: ArticleSectionProps) {
  const totalCount = Math.ceil(totalArticles / articlesPageSize);
  return (
    <div>
      <section className="rc-section text-center my-4">
        <div className="row my-5 justify-content-center position-relative align-items-stretch">
          {articles &&
            articles.map((u) => {
              return (
                <div className="col-md-4 col-lg-3 mb-4" key={u.id}>
                  <StyledCard className="h-100">
                    <StyledCardActionArea>
                      <a
                        href={u.article_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="title_url"
                      >
                        <ImageRP
                          src={
                            u.article_img?.startsWith("https")
                              ? u.article_img
                              : getImage(u.article_img || "", "BRAND")
                          }
                          type="IMG"
                          className="sg-image"
                        />
                      </a>
                    </StyledCardActionArea>
                    <CardContent>
                      <div className="d-flex justify-content-between">
                        <DateLine className="rc-date mt-3">
                          <Typography component="span" className="small">
                            {getFormatDate(
                              u?.article_date ? u?.article_date : u?.createdAt
                            )}
                          </Typography>
                        </DateLine>
                      </div>
                      <Title className="rc-title pt-3">
                        <Typography component="h5" variant="body1">
                          <a
                            href={u.article_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="title_url"
                          >
                            {u.article_title}
                          </a>
                        </Typography>
                      </Title>
                    </CardContent>
                  </StyledCard>
                </div>
              );
            })}
        </div>
        <div className="row d-flex row d-flex justify-content-center paging">
          <TablePagination
            count={totalCount}
            page={articlesPageIndex}
            onChange={handleArticlePageChange}
            variant="outlined"
            shape="rounded"
            className="float-right"
          />
        </div>
      </section>
    </div>
  );
});
